export default "__VITE_ASSET__17457129__"